import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    BehaviorSubject,
    Observable,
    catchError,
    retry,
    throwError,
} from 'rxjs';
import { IAppConfig } from '../interfaces/app-config';
import { AppConfigService } from 'src/app/services/app-config.service';
import { ContributorRequest } from '../models/add-contributor.model';
import { SubmitContributor } from '../models/submit-contributors.model';
import { IIepStaff } from 'src/app/modules/iep/iep-document/interfaces/iep-staff';
import { SubmitContributorData } from '../models/submit-contributor.model';
import { SubmitCancelMeetingModel } from '../models/cancel-meeting-model/submit-cancel-meeting-model';
import { SubmitCloseRequestExtensiongModel } from '../models/close-request-extension/submit-close-request-extension-model';
import { SubmitSudentRelatedEventsModel } from '../models/student-related-events-models/submit-student-related-event-model';
import { SubmitCaseClosingModel } from '../models/case-close-model/submit-case-close-model';

@Injectable({
    providedIn: 'root'
})
export class ContributorService {
    config: IAppConfig;

    isEditingStudentInfo$ = new BehaviorSubject<boolean>(false);

    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {
        this.config = this.appConfigService.getConfig();
    }
    public getContributors(dbn: string): Observable<IIepStaff[]> {
        return this.http
            .get<IIepStaff[]>(`${this.config.studentApiUrl}/Staff/Search/${dbn}`)
            .pipe(catchError(this.handleError));
    }

    public submit(request: SubmitContributorData[]): Observable<ContributorRequest[]> {
        return this.http.post<ContributorRequest[]>(`${this.config.apiUrl}/Contributor/AddContributor`, request)
            .pipe(catchError(this.handleError));
    }
    // Error handling
    handleError(error: any) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        //window.alert(errorMessage);
        return throwError(() => {
            return errorMessage;
        });
    }

    public submitCancelMeetingRequest(request: SubmitCancelMeetingModel): Observable<any> {
        return this.http.put(`${this.config.studentApiUrl}/Meeting/CancelMeeting`, request)
            .pipe(catchError(this.handleError));
    }
    public submitCloseRequestExtensiongRequest(request: SubmitCloseRequestExtensiongModel): Observable<any> {
        return this.http.put(`${this.config.studentApiUrl}/Meeting/CancelMeeting`, request)
            .pipe(catchError(this.handleError));
    }
    public submitStudentRelatedEvent(request: SubmitSudentRelatedEventsModel): Observable<any> {
        return this.http.post(`${this.config.studentApiUrl}/EventLog/Add`, request)
            .pipe(catchError(this.handleError));
    }
    public submitCaseCloseEvent(request: SubmitCaseClosingModel): Observable<any> {
        return this.http.post(`${this.config.apiUrl}/CaseClose/Add`, request)
            .pipe(catchError(this.handleError));
    }

    public getUserEvents(id: string): Observable<any> {
        return this.http
          .get<any[]>(`${this.config.studentApiUrl}/EventLog/UserEventLogs?caseactionSk=` + id)
          .pipe(catchError(this.handleError));
      }
}
